import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Link, Redirect } from 'react-router-dom';

import Checkbox from 'components/Checkbox';
import RectButton from 'components/RectButton';
import Tile from 'components/Tile';
import TitleWithShape from 'components/TitleWithShape';

import CheckIcon from 'assets/images/icons/check.svg';
import EditIcon from 'assets/images/icons/edit.svg';

const Wrapper = styled.div`
  .title-wrapper {
    margin: 6.8rem 35rem 7.1rem 16rem;
  }
  .content {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    margin-top: 7.1rem;
    padding-left: 5.4rem;
    padding-right: 5.4rem;

    .form-wrapper {
      display: flex;
      align-items: flex-start;
      justify-content: flex-start;
      flex-direction: column;
      background: #f8f7f3;
      color: #35447D;
      font-size: 1.5rem;
      padding: 2rem 7rem;
      width: 50%;
      max-width: 60rem;

      .inner-wrapper {
        display: flex;
        flex-direction: column;
        color: #35447D;
        margin-top: 4rem;
        position: relative;
        width: 100%;

        h2 { font-size: 1.75rem; }
        strong {
          font-family: Lato, 'Helvetica Neue', Arial, Helvetica;
          font-weight: 600;
        }
        .limit-wrapper {
          display: flex;
          align-items: flex-end;
          margin-bottom: 1rem;

          h2 {
            margin: 0;
            margin-right: 1rem;
          }
          img { margin-left: 1rem; }
        }
        .edit-wrapper {
          position: absolute;
          top: 0;
          right: 0;
          display: flex;

          img { margin-left: 1rem; }
        }
      }
      .bigger-text {
        font-size: 2.2rem;
        margin: 2.2rem 0;
        width: 100%;
      }
    }
    .right-wrapper {
      display: flex;
      align-items: flex-start;
      justify-content: flex-start;
      flex-direction: column;
      background: #ffffff;
      color: #35447D;
      font-size: 1.5rem;
      padding: 2rem 7rem;
      width: 50%;
      max-width: 60rem;

      .inner-wrapper {
        align-self: flex-end;
        max-width: 40rem;
        width: 100%;

        .item {
          color: #35447D;

          .heading {
            display: flex;
            align-items: baseline;
            margin-top: 4rem;
            margin-bottom: 0.83rem;

            h2 {
              font-size: 1.75rem;
              margin: 0;
              max-width: 19rem;
            }
            .edit-wrapper {
              display: flex;
              justify-content: center;
              margin-left: auto;

              img { margin-left: 1rem; }
            }
          }
          .gray-panel {
            background-color: #e1e1e1;
            margin-top: 2rem;
            padding: 1rem 4rem 4rem 4rem;

            .preference {
              display: flex;
              flex-direction: column;
              margin-top: 3rem;

              h3 {
                font-size: 1.6rem;
                margin: 0;
              }
              p {
                margin: 0;
                margin-top: 1rem;
              }
            }
          }
          .timeline-wrapper {
            margin-top: 2rem;

            .timeline {
              display: flex;
              cursor: pointer;
              margin-left: -2rem;

              .index-num {
                height: 10rem;
                width: 2px;
                background: #8aebf1;
                position: relative;

                .circle {
                  border-radius: 2.6rem;
                  width: 2.6rem;
                  height: 2.6rem;
                  text-align: center;
                  background: #35447d;
                  color: white;
                  position: absolute;
                  top: calc(50% - 1.8rem);
                  left: -1.3rem;
                  line-height: 2.6rem;
                }
              }
              .item-wrapper {
                flex: 1;
                margin-left: 2rem;
                height: 9rem;
                border: 1px solid #35447d;
                display: flex;
                flex-direction: column;
                margin-bottom: 1rem;

                .item-info {
                  flex: 1;
                  display: flex;
                  align-items: center;
                  padding: 0 2rem;
                  justify-content: space-between;
                }
                .attachments {
                  height: 2.4rem;
                  background: #f8f7f3;
                  line-height: 2.4rem;
                  padding-left: 2rem;
                  font-size: 1.2rem;
                }
              }
            }
          }

        }
      }
    }
  }

  @media only screen and (max-width: 1100px) {
    .content {
      flex-direction: column-reverse;

      .form-wrapper, .right-wrapper {
        max-width: 100%;
        width: 100%;
      }
      .right-wrapper {
        padding-top: 0;

        .inner-wrapper {
          align-self: flex-start;
          max-width: none;

          .sm-mt-0 {
            margin-top: 0 !important;
          }
        }
      }
    }
    .title-wrapper {
      margin: 4rem 6rem;
    }
  }
`;

class Step8 extends Component {
  constructor(props) {
    super(props);
    this.state = props.formData.step8;
    this.formData = props.formData;
    // Defaults
    this.state.invoice = this.state.invoice || true;
    this.state.terms = this.state.terms || false;
  }

  onCheck = (key) => {
    this.setState({ [key]: !this.state[key] });
  }

  nextFormPage() {
    if (!this.validate()) { return; }
    this.setState({ completed: true }, () => {
      this.props.collectData('step8', this.state);
      this.setState({ redirect: '/get-started/step-nine' });
    });
  }

  validate() {
    this.setState({ termsError: false });
    if (this.state.terms) {
      return true;
    }
    this.setState({ termsError: true });
    return false;
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to={this.state.redirect} push />;
    }

    return (
      <Wrapper>
        <div className="title-wrapper">
          <TitleWithShape
            title={
              <div>
                <span>Please review the information</span> you submitted<br />
                and make sure everything is correct.
              </div>
            }
            subTitle={
              <div>
                If you provide unaccurate representations of
                your situation our advice may not be valid.
              </div>
            }
          />
        </div>
        <div className="content">

          {/* Left wrapper */}
          <div className="form-wrapper">
            <Link to="/get-started" className="inner-wrapper">
              <h2>Contact details</h2>
              <p><strong>Name:</strong> {this.formData.step1.name}</p>
              <p><strong>Email:</strong> {this.formData.step1.email}</p>
              <p><strong>Phone:</strong> {this.formData.step1.phone}</p>
              {this.formData.forWho === 'other' && (
                <div>
                  <p><strong>Representing:</strong> {this.formData.step1.whoseBehalf}</p>
                  <p><strong>Role/Position:</strong> {this.formData.step1.relationshipWithPerson}</p>
                </div>
              )}
              <div className="edit-wrapper">
                Edit
                <img src={EditIcon} alt="Edit" />
              </div>
            </Link>

            <Link to="/get-started/step-two" className="inner-wrapper">
              <h2>Court Proceedings</h2>
              {this.formData.step2.courtProceedingsOption === 'Yes' && (
                <div>
                  <p><strong>Status:</strong> Yes, currently involved in proceedings.</p>
                  <p><strong>Court Name:</strong> {this.formData.step2.courtName}</p>
                  <p><strong>Proceedings number:</strong> {this.formData.step2.proceedingsNumber}</p>
                  <p><strong>Other party representatives:</strong> {this.formData.step2.whoRepresentsOtherParty}</p>
                  <p>
                    <strong>Your party: </strong>
                    {this.formData.step2.partyOption !== 'Other'
                      ? this.formData.step2.partyOption
                      : this.formData.step2.otherPartyField
                    }
                  </p>
                </div>
              )}

              {this.formData.step2.courtProceedingsOption === 'No' && (
                <p><strong>Status:</strong> No, currently not involved in proceedings.</p>
              )}

              {this.formData.step2.courtProceedingsOption === 'Maybe' && (
                <div>
                  <p><strong>How likely is it:</strong> {this.formData.step2.courtLikelyhoodOption}</p>
                  <p><strong>When might court proceedings commence:</strong> {this.formData.step2.courtCommencingOption}</p>
                </div>
              )}
              <div className="edit-wrapper">
                Edit
                <img src={EditIcon} alt="Edit" />
              </div>
            </Link>

            <Link to="/get-started/step-three" className="inner-wrapper">
              <h2>Matter Types</h2>
              {this.formData.step3.selectedMatters !== undefined
                ? this.formData.step3.selectedMatters.map((matter, i) => (
                  <p key={i}>
                    {matter.title}
                  </p>
                ))
                : <p>You have not selected any matters.</p>
              }
              <div className="edit-wrapper">
                Edit
                <img src={EditIcon} alt="Edit" />
              </div>
            </Link>

            <Link to="/get-started/step-four" className="inner-wrapper">
              <div className="limit-wrapper">
                <h2>Your question</h2>
                {this.formData.step4.limit}
                <img src={CheckIcon} alt="Check" />
              </div>

              <p>{this.formData.step4.question}</p>

              <div className="edit-wrapper">
                Edit
                <img src={EditIcon} alt="Edit" />
              </div>
            </Link>

            <p className="bigger-text">I agree that the information provided is, to the best of my knowledge, full and complete without error.</p>

            <Checkbox
              checked={this.state.terms}
              content={
                <span>
                  I have read and agree to the QuickLegal <a href="/privacy">Client Agreement and Privacy Policy</a>.
                </span>
              }
              error={this.state.termsError}
              isRequired
              name="terms"
              onCheck={this.onCheck}
            />
            <Checkbox
              checked={this.state.invoice}
              content={<span>Please email me the invoice for QuickLegal services. Do not send an invoice by post.</span>}
              name="invoice"
              onCheck={this.onCheck}
            />

            <RectButton
              color="#8AEBF1"
              width={26}
              title="Accept and proceed"
              onClick={() => this.nextFormPage()}
              leftMargin="auto"
            />
          </div>

          {/* Right wrapper */}
          <div className="right-wrapper">
            <div className="inner-wrapper">
              <Link to="/get-started/step-five" className="item">
                <div className="heading sm-mt-0">
                  <h2>Uploaded</h2>
                  <div className="edit-wrapper">
                    Edit
                    <img src={EditIcon} alt="Edit" />
                  </div>
                </div>
                <div className="upload-container">
                  {this.formData.documents !== undefined && this.formData.documents.length > 0
                    ? (this.formData.documents.map((file, index) => (
                      <Tile
                        key={index}
                        date={file.documentDate}
                        description={file.description}
                        name={file.fileName.toUpperCase()}
                      />))
                    )
                    : <p>No documents uploaded</p>
                  }
                </div>
              </Link>

              <Link to="/get-started/step-six" className="item">
                <div className="heading">
                  <h2>Timeline</h2>
                  <div className="edit-wrapper">
                    Edit
                    <img src={EditIcon} alt="Edit" />
                  </div>
                </div>
                <div className="timeline-wrapper">
                  {this.formData.step6.events !== undefined && this.formData.step6.events.length > 0
                    ? (
                      this.formData.step6.events.sort((a, b) => a.date - b.date).map((event, index) => (
                        <div className="timeline">
                          <div className="index-num">
                            <div className="circle">{index + 1}</div>
                          </div>
                          <div className="item-wrapper">
                            <div className="item-info">
                              <div className="text">
                                <h4>{new Date(event.date).toDateString()}</h4>
                                <p>{event.title}</p>
                              </div>
                            </div>
                            <div className="attachments">
                              {event.documents.length} document links
                            </div>
                          </div>
                        </div>))
                    )
                    : <p>No timeline events added.</p>
                  }
                </div>
              </Link>

              <Link to="/get-started/step-seven" className="item">
                <div className="heading">
                  <h2>Conference Preferences</h2>
                  <div className="edit-wrapper">
                    Edit
                    <img src={EditIcon} alt="Edit" />
                  </div>
                </div>
                <div className="gray-panel">
                  {this.formData.step7.preferences !== undefined
                    ? (
                      this.formData.step7.preferences.map((obj, i) => (
                        <div className="preference">
                          <h3>Preference #{i + 1}</h3>
                          <p><strong>Date:</strong> {new Date(obj.date).toDateString()}</p>
                          <p><strong>Time:</strong> {obj.between} - {obj.and}</p>
                        </div>))
                    )
                    : <p>No preferences added.</p>
                  }
                </div>
              </Link>
            </div>
          </div>

        </div>
      </Wrapper>
    );
  }
}

Step8.propTypes = {
  collectData: PropTypes.func.isRequired,
  formData: PropTypes.objectOf(PropTypes.object).isRequired,
};

export default Step8;



// WEBPACK FOOTER //
// ./src/containers/BeginPage/Step8.js